import React from 'react'
import { ReactComponent as CrossIcon } from 'icons/cross-16.svg'

interface RemoveMemberButtonProps {
  onClick: () => void
  className?: string
  disabled?: boolean
}

const RemoveMemberButton = ({
  onClick,
  className,
  disabled,
}: RemoveMemberButtonProps) => {
  return (
    <button
      onClick={onClick}
      data-testid="remove-member"
      className={className}
      aria-label="remove member"
      disabled={disabled}>
      <CrossIcon width={16} height={16} aria-hidden={true} />
    </button>
  )
}

export default RemoveMemberButton
